import React from 'react';
import { useI18n, SUPPORTED_LANGS } from '../../i18n';
import './LanguageSwitcher.css';

const LABELS = { tr: 'TR', en: 'EN' };
const NAMES = { tr: 'Türkçe', en: 'English' };

// Two-option TR | EN segmented switch. `tone` picks the palette for the
// surface it sits on: 'dark' (landing nav, sidebar) or 'light' (cards).
function LanguageSwitcher({ tone = 'dark', className = '' }) {
  const { lang, setLang } = useI18n();
  return (
    <div
      className={`lang-switch lang-switch--${tone} ${className}`.trim()}
      role="group"
      aria-label={lang === 'tr' ? 'Dil' : 'Language'}
    >
      {SUPPORTED_LANGS.map(code => (
        <button
          key={code}
          type="button"
          lang={code}
          className={`lang-switch-btn${lang === code ? ' is-active' : ''}`}
          aria-pressed={lang === code}
          title={NAMES[code]}
          onClick={() => setLang(code)}
        >
          {LABELS[code]}
        </button>
      ))}
    </div>
  );
}

export default LanguageSwitcher;
